import React, { useCallback, useState } from 'react';
import { Dropdown } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useImportExport } from '../../ImportExport';
import { ShareDialog } from '../../ShareModal/ShareModal';
import { useMenuItems } from './useMenuItems';
import { useCloseAboveCompact } from './useCloseAboveCompact';
import styles from './RightHeaderMenu.module.css';

/**
 * Hamburger for small screens (hidden from 768px up): the map tools, members,
 * share, theme and apps as rows. Dialogs the rows open render here, outside
 * the dropdown, so their clicks and keys never reach the menu.
 */
const RightHeaderMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isShareOpen, setIsShareOpen] = useState(false);
    const close = useCallback(() => setIsOpen(false), []);
    const { startImport, startExport, holder } = useImportExport();
    const menu = useMenuItems({ close, onImport: startImport, onExport: startExport, onShare: () => setIsShareOpen(true) });
    useCloseAboveCompact(close);

    return (
        <div className={styles.root}>
            <Dropdown
                menu={menu}
                trigger={['click']}
                open={isOpen}
                onOpenChange={setIsOpen}
                placement="bottomRight"
                overlayClassName={styles.menu}
            >
                <button
                    type="button"
                    className={`${styles.hamburger} ${isOpen ? styles.hamburgerActive : ''}`.trim()}
                    aria-label="Menu"
                    aria-expanded={isOpen}
                >
                    <MenuOutlined />
                </button>
            </Dropdown>
            {holder}
            <ShareDialog open={isShareOpen} onClose={() => setIsShareOpen(false)} />
        </div>
    );
};

export default RightHeaderMenu;
